import logger from './logger';

// a write helper that reads first catches the error its read already reported, so each error is reported once,
// under the operation that failed first
const reportedErrors = new WeakSet();

const isPermissionDenied = (error) => error?.code === 'permission-denied';

const buildMessage = (operation, path, error) => `${operation} ${path}: ${error?.code ?? ''} ${error?.message ?? ''}`;

const report = (eventName, operation, path, error) => {
    if (error instanceof Object) {
        if (reportedErrors.has(error)) {
            return;
        }
        reportedErrors.add(error);
    }

    logger.logErrorEvent(eventName, error, buildMessage(operation, path, error), true);
    // the issue shows what failed; the tracked event is what an alert can count
    logger.trackEvent(eventName, { operation, path: path ?? null, code: error?.code ?? null });
};

// a failed write is otherwise only a console line in one browser. this makes it a logrocket issue, and a rules denial
// gets its own event name so it can be alerted on apart from every other kind of failure
export const reportFirestoreWriteError = (operation, path, error) => {
    report(isPermissionDenied(error) ? 'FIRESTORE_PERMISSION_DENIED' : 'FIRESTORE_WRITE_FAILED', operation, path, error);
};

// a failed read reaches its caller, which may still swallow it, so a rules denial is reported on the way through
export const reportFirestoreReadError = (operation, path, error) => {
    if (isPermissionDenied(error)) {
        report('FIRESTORE_PERMISSION_DENIED', operation, path, error);
    }
};
